import QuestionChallenge from './question-challenge';

export default QuestionChallenge;
